var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearchIconSclad = function SvgSearchIconSclad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#4B97E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.75C8.86739 11.75 8.74021 11.8027 8.64645 11.8964C8.55268 11.9902 8.5 12.1174 8.5 12.25V18.5C8.5 18.6326 8.55268 18.7598 8.64645 18.8536C8.74021 18.9473 8.86739 19 9 19C9.13261 19 9.25979 18.9473 9.35355 18.8536C9.44732 18.7598 9.5 18.6326 9.5 18.5V12.25C9.5 12.1174 9.44732 11.9902 9.35355 11.8964C9.25979 11.8027 9.13261 11.75 9 11.75Z",
    fill: "#4B97E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.75C18.8674 11.75 18.7402 11.8027 18.6464 11.8964C18.5527 11.9902 18.5 12.1174 18.5 12.25V18.5C18.5 18.6326 18.5527 18.7598 18.6464 18.8536C18.7402 18.9473 18.8674 19 19 19C19.1326 19 19.2598 18.9473 19.3536 18.8536C19.4473 18.7598 19.5 18.6326 19.5 18.5V12.25C19.5 12.1174 19.4473 11.9902 19.3536 11.8964C19.2598 11.8027 19.1326 11.75 19 11.75Z",
    fill: "#4B97E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.5H12.5C12.3619 12.5 12.25 12.6119 12.25 12.75V15.25C12.25 15.3881 12.3619 15.5 12.5 15.5H15.5C15.6381 15.5 15.75 15.3881 15.75 15.25V12.75C15.75 12.6119 15.6381 12.5 15.5 12.5Z",
    fill: "#4B97E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16H14.5C14.3619 16 14.25 16.1119 14.25 16.25V18.75C14.25 18.8881 14.3619 19 14.5 19H17.5C17.6381 19 17.75 18.8881 17.75 18.75V16.25C17.75 16.1119 17.6381 16 17.5 16Z",
    fill: "#4B97E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16H10.5C10.3619 16 10.25 16.1119 10.25 16.25V18.75C10.25 18.8881 10.3619 19 10.5 19H13.5C13.6381 19 13.75 18.8881 13.75 18.75V16.25C13.75 16.1119 13.6381 16 13.5 16Z",
    fill: "#4B97E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8275 8.7705C19.3535 8.355 17.531 7 14 7C10.469 7 8.6465 8.355 8.1725 8.7705C8.11814 8.81762 8.07459 8.87592 8.04482 8.94142C8.01505 9.00691 7.99976 9.07806 8 9.15V10.778C8.00093 10.9127 8.05524 11.0416 8.15103 11.1364C8.24681 11.2311 8.37627 11.284 8.511 11.2835H19.489C19.6237 11.284 19.7532 11.2311 19.849 11.1364C19.9448 11.0416 19.9991 10.9127 20 10.778V9.15C20.0002 9.07806 19.985 9.00691 19.9552 8.94142C19.9254 8.87592 19.8819 8.81762 19.8275 8.7705Z",
    fill: "#4B97E9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchIconSclad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search_icon_sclad.ff66e626.svg";
export { ForwardRef as ReactComponent };